//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BasePageWrapper from '@/components/v2/wrapper/BasePageWrapper.vue'
import headRTLMixin from '~/mixins/headRTL.mixin'

export default {
  name: 'Python',
  components: {
    BasePageWrapper,
  },
  mixins: [headRTLMixin],
}
